module.exports = __webpack_public_path__ + "img/charter.8b53c6ab.svg";